// 📁 components/categoria/AsociacionNavigation.jsx
import React from "react";
import { Typography, Box } from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BusinessIcon from "@mui/icons-material/Business";
import {
  TopNavigation,
  NavHeader,
  AsociacionesContainer,
  AsociacionChip,
  GubernamentalChip,
  ChipHeader,
  ChipTitle,
  ChipSubtitle,
  BadgeStyled,
  theme
} from "../../styles/CategoriaStyles";
import { getRepresentantesGubernamentales } from "../../utils/representanteUtils";

const AsociacionNavigation = ({ 
  asociaciones = [], 
  representantes = [],
  selectedAsociacion, 
  onSelectAsociacion, 
  expandedGubernamental, 
  setExpandedGubernamental 
}) => {
  const representantesGubernamentales = getRepresentantesGubernamentales(representantes);

  const getTotalRepresentantesAsociacion = (asociacion) => {
    return representantes.filter(
      (rep) => 
        rep.cod_asociacion === asociacion.cod_asociacion && 
        rep.categorias?.some(cat => cat.Estado !== 'Inactivo') &&
        rep.estatus !== 'INHABILITADO' // Excluir representantes inhabilitados
    ).length;
  };

  return (
    <TopNavigation>
      <NavHeader>
        <Typography 
          variant="h5" 
          sx={{ 
            mb: 2, 
            color: theme.palette.primary.main, 
            fontWeight: 700,
            fontSize: { xs: "1.2rem", md: "1.5rem" }
          }}
        >
         CATEGORÍAS DE LAS ORGANIZACIONES
        </Typography>
       
      </NavHeader>

      <AsociacionesContainer>
     
        <GubernamentalChip
          expanded={expandedGubernamental}
          onClick={() => setExpandedGubernamental(!expandedGubernamental)}
        >
          <ChipHeader>
            <AccountBalanceIcon sx={{ fontSize: 20 }} />
          </ChipHeader>
          <ChipTitle>SECRETARÍAS</ChipTitle>
         
        
        </GubernamentalChip>

        {/* Chips de Asociaciones */}
        {asociaciones.map((asociacion) => {
          const totalRepresentantes = getTotalRepresentantesAsociacion(asociacion);
          const isSelected = selectedAsociacion?.cod_asociacion === asociacion.cod_asociacion;

          return (
            <AsociacionChip
              key={asociacion.cod_asociacion}
              selected={isSelected}
              onClick={() => onSelectAsociacion(asociacion)}
            >
              <ChipHeader>
                <BusinessIcon sx={{ fontSize: 20 }} />
              </ChipHeader>
              <ChipTitle selected={isSelected}>
                {asociacion.nombre_abreviado}
              </ChipTitle>
             
            
            </AsociacionChip>
          );
        })}
      </AsociacionesContainer>
    </TopNavigation>
  );
};

export default AsociacionNavigation;